import template from './noteEdit.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdDialog,
      $mdMedia,
      eventService,
      uiService,
      fileFactory,
      noteService,
      Note,
      NOTE,
      NoteAttribute,
      Document
    ) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.currentAccount = null;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = function () {
        ctrl.currentAccount = $rootScope.CurrentAccount;

        ctrl.destroyWatch = eventService.onNoteEdit((params) => {
          $mdDialog
            .show({
              targetEvent: params.event,
              locals: {
                note: params.note ? angular.copy(params.note) : Note.blank(),
                list: params.list,
                url: params.url,
                ticket: params.ticket ? params.ticket : null,
                contact: params.contact ? params.contact : null,
                title: params.title,
                allowedMimeTypes: params.allowedMimeTypes,
                allowedExtensions: params.allowedExtensions
              },
              template,
              controllerAs: '$ctrl',
              controller(
                scope,
                note,
                list,
                url,
                ticket,
                contact,
                title,
                allowedMimeTypes,
                allowedExtensions
              ) {
                const ctr = this;

                ctr.note = note;
                ctr.isEditingNote = _.isUuid(note.id);
                ctr.note.content = ctr.note.getContent();
                ctr.files = [];
                ctr.url = url;
                ctr.idTicket = ticket !== null ? ticket.id : '';
                ctr.idWorkflow = ticket !== null ? ticket.idWorkflow : '';
                ctr.ticketName = ticket !== null ? ticket.getName() : '';
                ctr.idContact = contact !== null ? contact.id : '';
                ctr.title = title;
                ctr.allowedMimeTypes = allowedMimeTypes;
                ctr.allowedExtensions = allowedExtensions;
                ctrl.isNoteForContact = ctr.idContact !== '';
                ctr.startUpload = false;
                ctr.notePinned = () => {
                  ctr.note.isPinned = !ctr.note.isPinned;
                };
                ctr.attributeAdd = () => {
                  ctr.note.attributes.push(NoteAttribute.blank());
                };
                ctr.attributeDelete = (index) => {
                  ctr.note.attributes.splice(index, 1);
                };
                ctr.noteShared = () => {
                  ctr.note.isShared = !ctr.note.isShared;
                };
                ctr.noteSharedPartner = () => {
                  ctr.note.isSharedPartner = !ctr.note.isSharedPartner;
                };

                ctr.removeAttachment = (attachment) => {
                  ctr.note.attachments = _.reject(
                    ctr.note.attachments,
                    (att) => att.id === attachment.id
                  );
                };

                ctr.downloadAttachment = (data) => {
                  fileFactory
                    .getDownloadUrl({
                      url: NOTE.API.DOWNLOAD,
                      file: data.file,
                      name: data.name
                    })
                    .then((downloadUrl) => {
                      fileFactory.download(downloadUrl);
                    });
                };

                ctr.downloadAttachmentPdf = (data) => {
                  fileFactory
                    .getDownloadUrl({
                      url: NOTE.API.DOWNLOAD_PDF,
                      file: data.file,
                      name: data.name
                    })
                    .then((downloadUrl) => {
                      fileFactory.download(downloadUrl);
                    });
                };

                ctr.uploadFinished = (files) => {
                  $mdDialog.hide({
                    note: ctr.note,
                    attachments: files,
                    idTicket: ctr.idTicket,
                    idWorkflow: ctr.idWorkflow,
                    idContact: ctr.idContact
                  });
                };

                ctr.confirm = () => {
                  if (ctr.note.content !== '') {
                    if (
                      scope.noteEdit.files &&
                      scope.noteEdit.files.$viewValue &&
                      scope.noteEdit.files.$viewValue.length
                    ) {
                      ctr.startUpload = true;
                      ctr.files = scope.noteEdit.files.$viewValue;
                    } else {
                      $mdDialog.hide({
                        note: ctr.note,
                        attachments: [],
                        idTicket: ctr.idTicket,
                        idWorkflow: ctr.idWorkflow,
                        idContact: ctr.idContact
                      });
                    }
                  } else {
                    uiService.toast({
                      text: {
                        p1: 'Note',
                        p2: 'content',
                        p3: 'is required'
                      },
                      warn: true
                    });
                  }
                };
                ctr.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then((res) => {
              const result = res;
              for (let a = 0; a < result.attachments.length; a += 1) {
                const attachment = Document.blank();
                attachment.idOwner = ctrl.currentAccount.id;
                attachment.name = result.attachments[a].name;
                attachment.file = result.attachments[a].file;
                attachment.isShared = result.note.isShared === true;
                attachment.isSharedPartner = result.note.isSharedPartner === true;
                result.note.attachments.push(attachment);
              }

              if (!_.isUuid(result.note.id)) {
                result.note.idTicket = result.idTicket;
                result.note.idWorkflow = result.idWorkflow;
                result.note.idContact = result.idContact;
                result.note.type = 'comment';
                result.note.content = result.note.content.cleanHtml();
                noteService.createNote(result.note).then((data) => {
                  if (data.status) {
                    result.note.id = data.id;
                    result.note.idOwner = ctrl.currentAccount.id;
                    result.note.isNew = true;
                    ctrl.onFinished({ note: result.note });
                    uiService.toast({
                      text: {
                        p1: 'Note',
                        p2: result.note.getExcerpt(),
                        p3: 'has been added'
                      }
                    });
                  }
                });
              } else {
                result.note.content = result.note.content.cleanHtml();
                noteService.updateNote(result.note).then((data) => {
                  if (data.status) {
                    ctrl.onFinished({ note: result.note });
                    uiService.toast({
                      text: {
                        p1: 'Note',
                        p2: result.note.getExcerpt(),
                        p3: 'has been updated'
                      }
                    });
                  }
                });
              }
            });
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = function () {
        ctrl.destroyWatch();
      };
    }
  }
};
